{
  "breadcrumbAriaLabel": "麵包屑導覽",
  "homeAriaLabel": "首頁",
  "mainNavAriaLabel": "主導覽",
  "closeSidebarAriaLabel": "關閉側邊欄",
  "collapse": "收合",
  "help": "說明",
  "settings": "設定",
  "myProfile": "我的個人檔案",
  "groups": {
    "clinical": "臨床",
    "worklists": "工作清單",
    "documentation": "病歷文件",
    "orders": "醫囑",
    "medications": "藥物",
    "scheduling": "預約編排",
    "billing": "賬務",
    "analytics": "分析",
    "organization": "機構組織",
    "security": "保安",
    "accessReviews": "Access Reviews",
    "integrations": "整合",
    "system": "系統",
    "licensing": "授權"
  },
  "dashboard": "儀表板",
  "patients": "病人管理",
  "patientSearch": "病人搜尋",
  "myPatients": "我的病人",
  "censusBedBoard": "在院名單 / 床位看板",
  "providerDirectory": "醫生目錄",
  "providerCoverage": "醫生當值覆蓋",
  "patientMerge": "病人紀錄合併",
  "inbox": "收件箱",
  "pendingResults": "待簽結果",
  "criticalResults": "危急結果",
  "unsignedNotes": "未簽署病歷",
  "cosignQueue": "共同簽署佇列",
  "noteTemplates": "病歷範本",
  "smartPhrases": "智能短語",
  "orderCatalog": "醫囑目錄",
  "orderSets": "醫囑組合",
  "encounters": "求診紀錄",
  "orders": "醫囑",
  "results": "檢驗檢查結果",
  "medications": "藥物",
  "notes": "病歷文件",
  "medicationWorklist": "Medication Worklist",
  "formulary": "藥物名冊",
  "pharmacistQueue": "藥劑師審核佇列",
  "appointments": "預約",
  "scheduleManagement": "編排管理",
  "waitlist": "候診名單",
  "charges": "收費",
  "claims": "賠償申請",
  "payments": "付款",
  "accounts": "賬戶",
  "statements": "結算單",
  "denials": "拒賠",
  "analyticsDashboard": "儀表板",
  "reports": "報表",
  "qualityMeasures": "質素指標",
  "healthSystems": "醫療集團",
  "facilities": "醫療機構",
  "locations": "院區位置",
  "clinicalTaxonomy": "臨床分類",
  "serviceLocation": "服務 ↔ 地點",
  "providers": "醫護人員",
  "users": "使用者",
  "roles": "角色",
  "accessMatrix": "權限矩陣",
  "integrations": "整合",
  "thirdPartyApps": "第三方應用程式",
  "audit": "審計",
  "system": "系統",
  "cdsRules": "CDS 規則",
  "escalationRules": "Escalation Rules",
  "segments": {
    "search": "搜尋",
    "register": "登記",
    "demographics": "基本資料",
    "census": "在院名單",
    "discharge": "出院",
    "catalog": "目錄",
    "sets": "醫囑組合",
    "pending": "待處理",
    "critical": "危急",
    "reconciliation": "用藥對照",
    "worklist": "工作清單",
    "templates": "範本",
    "smartPhrases": "智能短語",
    "schedule": "編排管理",
    "quality": "質素指標",
    "administration": "管理",
    "auditLog": "審計紀錄",
    "allergies": "過敏紀錄",
    "problems": "問題清單",
    "immunizations": "疫苗接種",
    "insurance": "保險"
  },
  "handoffs": "交接",
  "duplicateReview": "重複病歷審核",
  "sso": "SSO & Directories",
  "userGroups": "User Groups",
  "fileKey": "File key",
  "ordersWorklist": "醫囑工作清單"
}
